import { Component } from '@angular/core';
import { BaseComponent } from "../../base/base-component.component";
import { TranslateService } from "@ngx-translate/core";
import { AppConfigProvider } from '../../app-config.provider';

@Component({
  selector: 'footer-main',
  templateUrl: './footer-main.component.html',
})
export class FooterMainComponent extends BaseComponent {

  lastUpdateDays: number;
  goLiveVersion: string;
  goLiveDate: string;

  constructor(
    protected readonly translateService: TranslateService,
    private readonly appConfigProvider: AppConfigProvider) {
    super(translateService);
    this.setTranslateContext('FooterMainComponent');
    this.goLiveVersion = this.appConfigProvider.publishVersion();
    this.goLiveDate = this.appConfigProvider.publishDate();
    this.lastUpdateDays = this.getNumberOfDays(new Date(this.goLiveDate));
    if (this.lastUpdateDays === 0) {
      this.lastUpdateDays = 1;
    }
  }
}
